module.exports = __webpack_public_path__ + "static/media/Molley-May-teaches-Art.fa850e56.jpg";